/*
 * DC PDP v2 — "More like this — across our roasters" + sold-out alternatives (TASTE-4 / TASTE-5).
 *
 * Loaded deferred by sections/product-template.liquid:
 *   <script src="{{ 'dc-pdp-taste.js' | asset_url }}" defer></script>
 *
 * Reads   #dcPdpData (JSON: handle, title, vendor, available, families, origins, processes, roast, ...)
 * Fetches the compact taste index served by templates/collection.dc-taste.liquid:
 *           /collections/types?q=Coffee&view=dc-taste  +  /collections/types?q=&view=dc-taste  (blank-type roasts)
 *         lazily (idle after load, or when #dcMoreLike is near the viewport; immediately on sold-out products),
 *         cached in sessionStorage for 10 minutes.
 * Scores  in-stock coffees from OTHER roasters: shared flavour families > shared process > shared origin > same roast,
 *         plus a small boost for review count; decaf only matches decaf; 4 picks with distinct roasters.
 * Writes  cards into #dcMoreLike [data-dc-cards] and un-hides #dcMoreLike when there are >= 2 picks (its subtitle
 *         [data-dc-more-sub] names only the kinds of match the cards actually share);
 *         on sold-out products, compact rows into #dcAlts (replacing the Liquid skeleton rows), the shared reason into
 *         [data-dc-alts-reason], and shows the panel's fallback link ([data-dc-alts-fallback]) only with < 2 alternatives.
 * Degrades: a failed or slow (> 8 s) index or 0 picks on a sold-out page -> noAlts(): heading "This one's sold out",
 *         skeleton removed, fallback link shown, data-dc-alts-count="0" (the sticky bar then offers "Browse coffees").
 *         #dcMoreLike simply stays hidden.
 * Cards are links only (no add-to-cart), and link to product.url without ?variant=.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) { module.exports = api; return; }
  root.dcPdpTaste = api;
  try { api.boot(); } catch (e) { /* never break the PDP */ }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var KEY = 'dcTasteIdx:v1';
  var TTL = 10 * 60 * 1000;
  var MAX_PAGES = 4;
  var PICKS = 4;
  var FAM_COLORS = {
    'chocolate': '#6b4331', 'caramel': '#b8772a', 'nutty': '#9a7550', 'berry': '#7b3d78',
    'stone fruit': '#d2703f', 'tropical': '#d99a00', 'citrus': '#c9a400', 'floral': '#b25f8e'
  };
  var ROAST_LABEL = { espresso: 'Espresso roast', filter: 'Filter roast', omni: 'Omni roast' };
  var NUM_WORD = ['', 'one', 'two', 'three', 'four', 'five', 'six'];
  var SOLDOUT_TIMEOUT = 8000;
  var TITLE_NONE = 'This one\u2019s sold out';
  var TITLE_ONE = 'This one\u2019s sold out \u2014 a similar coffee in stock';
  var TITLE_MANY = 'This one\u2019s sold out \u2014 similar coffees in stock';

  /* ---------------- pure helpers (also used by the test harness) ---------------- */
  function lc(s) { return String(s == null ? '' : s).toLowerCase().trim(); }
  function strip(s, w) { return s.split(w).join(''); }
  /* same normalisation as dc-pdp-meta / the index: 'AXIL Coffee Roasters' and 'Axil Coffee' -> 'axil' */
  function vkey(v) { return strip(strip(strip(lc(v), ' coffee roasters'), ' roasters'), ' coffee').trim(); }
  function arr(a) { return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x.trim(); }) : []; }
  function uniqLc(a) {
    var seen = {}, out = [];
    arr(a).forEach(function (x) { var k = lc(x); if (!seen[k]) { seen[k] = 1; out.push(x.trim()); } });
    return out;
  }
  /* process base: 'Anaerobic Natural' ~ 'Natural', 'Red Honey' ~ 'Honey' (pulped natural stays its own process) */
  function procBase(p) {
    var k = lc(p);
    if (/^(an)?aerobic natural$/.test(k)) return 'natural';
    if (/^(black|red|yellow|white) honey$/.test(k)) return 'honey';
    return k;
  }
  function isDecaf(s) { return /decaf/i.test(s || ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof theme !== 'undefined' && theme.moneyFormat) {
        var f = Shopify.formatMoney(n, theme.moneyFormat);
        if (f) return String(f).replace(/<[^>]*>/g, '');
      }
    } catch (e) { /* fall through */ }
    return '$' + (n / 100).toFixed(2);
  }

  /* The current product's signals: #dcPdpData first, merged with its own index record when it has one. */
  function currentSignals(d, index) {
    var own = null;
    for (var i = 0; i < index.length; i++) if (index[i].h === d.handle) { own = index[i]; break; }
    var fams = arr(d.families), origins = arr(d.origins), procs = arr(d.processes);
    if (own) { fams = fams.concat(arr(own.f)); origins = origins.concat(arr(own.o)); procs = procs.concat(arr(own.r)); }
    var roast = lc(d.roast) || (own ? lc(own.b) : '');
    return {
      handle: d.handle, vk: vkey(d.vendor || (own && own.v) || ''),
      fams: uniqLc(fams), origins: uniqLc(origins), procs: uniqLc(procs), roast: roast,
      decaf: isDecaf(d.handle) || isDecaf(d.title) || !!(own && own.d)
    };
  }

  /* Score every candidate and pick up to n with distinct roasters. Returns [{rec, score, reason:[{k,label,fam}]}]. */
  function pick(cur, index, n) {
    n = n || PICKS;
    var pool = index.filter(function (r) { return r && r.h && r.a !== false; });
    var N = Math.max(pool.length, 1), dfF = {}, dfP = {}, dfO = {};
    pool.forEach(function (r) {
      uniqLc(r.f).forEach(function (x) { var k = lc(x); dfF[k] = (dfF[k] || 0) + 1; });
      var pb = {}; uniqLc(r.r).forEach(function (x) { pb[lc(x)] = 1; pb[procBase(x)] = 1; });
      Object.keys(pb).forEach(function (k) { dfP[k] = (dfP[k] || 0) + 1; });
      uniqLc(r.o).forEach(function (x) { var k = lc(x); dfO[k] = (dfO[k] || 0) + 1; });
    });
    function idf(df) { return Math.log(N / Math.max(df || 1, 1)); }
    var curF = cur.fams.map(lc), curO = cur.origins.map(lc);
    var scored = [];
    pool.forEach(function (r) {
      if (r.h === cur.handle) return;
      var rk = vkey(r.v);
      if (!rk || rk === cur.vk) return;
      if (!!r.d !== !!cur.decaf) return;
      var score = 0;
      /* 1. shared flavour families: rarer families weigh more; a coffee listing many families
            (a 'matches everything' blend) is damped */
      var fams = [], rf = uniqLc(r.f), damp = rf.length > 3 ? Math.sqrt(3 / rf.length) : 1;
      rf.forEach(function (x) {
        var k = lc(x), i = curF.indexOf(k);
        if (i < 0) return;
        var w = 1.0 + Math.min(2.5, 1.2 * idf(dfF[k]));
        score += w * damp;
        fams.push({ k: 'f:' + k, label: k, fam: k, w: w });
      });
      fams.sort(function (a, b) { return b.w - a.w; });
      /* 2. shared process (exact, else same base process at 80%) — counted once */
      var proc = null;
      cur.procs.forEach(function (p) {
        if (proc) return;
        var pk = lc(p);
        uniqLc(r.r).forEach(function (q) { if (!proc && lc(q) === pk) proc = { k: 'p:' + pk, label: pk + ' process', w: 0.8 + Math.min(0.7, 0.5 * idf(dfP[pk])) }; });
      });
      if (!proc) cur.procs.forEach(function (p) {
        if (proc) return;
        var pb = procBase(p);
        uniqLc(r.r).forEach(function (q) { if (!proc && procBase(q) === pb) proc = { k: 'p:' + pb, label: pb + ' process', w: 0.8 * (0.8 + Math.min(0.7, 0.5 * idf(dfP[pb]))) }; });
      });
      if (proc) score += proc.w;
      /* 3. shared origin countries (max 2 counted) */
      var origs = [];
      uniqLc(r.o).forEach(function (x) {
        var k = lc(x), i = curO.indexOf(k);
        if (i < 0 || origs.length >= 2) return;
        var w = 0.6 + Math.min(0.6, 0.3 * idf(dfO[k]));
        score += w;
        origs.push({ k: 'o:' + k, label: cur.origins[i], w: w });
      });
      if (!fams.length && !proc && !origs.length) return; /* roast alone is not a taste match */
      /* 4. roast: same roast lifts a little; an espresso/filter clash only fills slots left after compatible roasts */
      var rb = lc(r.b), cb = cur.roast, clash = false;
      if (rb && cb) {
        if (rb === cb) score += 0.4;
        else if (rb === 'omni' || cb === 'omni') score += 0.2;
        else clash = true;
      }
      /* 5. small boost for review count */
      var c = Number(r.c) || 0;
      if (c > 0) score += Math.min(0.4, 0.1 * Math.log(1 + c));
      /* reason: up to 2 families (rarest first), then process, then origin, then more families; max 3 items */
      var reason = fams.slice(0, 2);
      if (proc) reason.push(proc);
      origs.forEach(function (o) { reason.push(o); });
      fams.slice(2).forEach(function (f) { reason.push(f); });
      reason = reason.slice(0, 3);
      scored.push({ rec: r, vk: rk, clash: clash, score: Math.round(score * 1000) / 1000, reason: reason });
    });
    scored.sort(function (a, b) {
      return (b.score - a.score) || ((Number(b.rec.c) || 0) - (Number(a.rec.c) || 0)) || (a.rec.h < b.rec.h ? -1 : 1);
    });
    var out = [], used = {};
    [false, true].forEach(function (pass) {
      for (var i = 0; i < scored.length && out.length < n; i++) {
        var c = scored[i];
        if (c.clash !== pass || used[c.vk] || !c.reason.length) continue;
        used[c.vk] = 1;
        out.push(c);
      }
    });
    return out;
  }

  /* Mockup format: flavour families joined with ", ", then process and "from <origin>" joined with " · "
     e.g. "berry, caramel, chocolate · natural process · from Ethiopia" */
  function reasonLabel(it) { return it.k.charAt(0) === 'o' ? 'from ' + it.label : it.label; }
  function reasonJoin(items, fmt) {
    var fams = [], rest = [];
    items.forEach(function (it) { (it.fam ? fams : rest).push(fmt(it)); });
    var out = [];
    if (fams.length) out.push(fams.join(', '));
    return out.concat(rest).join(' · ');
  }
  function reasonText(items) {
    return reasonJoin(items, reasonLabel);
  }
  function reasonHTML(items) {
    return reasonJoin(items, function (it) {
      if (it.fam) {
        var c = FAM_COLORS[it.fam] || '#8a8a8a';
        return '<span class="dct-nw"><span class="dct-d" style="--c:' + c + '" aria-hidden="true"></span>' + esc(it.label) + '</span>';
      }
      return '<span class="dct-nw">' + esc(reasonLabel(it)) + '</span>';
    });
  }
  /* The kinds of match present across the picks, in a fixed order: e.g. ['flavour', 'process'] */
  function kindsOf(picks) {
    var has = {};
    picks.forEach(function (p) { p.reason.forEach(function (it) { has[it.k.charAt(0)] = 1; }); });
    var out = [];
    if (has.f) out.push('flavour');
    if (has.p) out.push('process');
    if (has.o) out.push('origin');
    return out;
  }
  function orList(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' or ' + a[a.length - 1]; }
  /* Sold-out panel: the reason items every pick shares (said once in the panel header). */
  function sharedReason(picks) {
    if (picks.length < 2) return { common: [] };
    return { common: picks[0].reason.filter(function (it) {
      return picks.every(function (p) { return p.reason.some(function (x) { return x.k === it.k; }); });
    }) };
  }

  /* ---------------- index fetch + cache ---------------- */
  function rootPath() {
    try { if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root; } catch (e) { /* ignore */ }
    return '/';
  }
  function cacheGet(k) {
    try {
      var raw = window.sessionStorage.getItem(k);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || !Array.isArray(o.p) || Date.now() - o.t > TTL) return null;
      return o.p;
    } catch (e) { return null; }
  }
  function cacheSet(k, p) {
    try { window.sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), p: p })); } catch (e) { /* quota / private mode */ }
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) { return JSON.parse(t); });
  }
  function fetchSource(base) {
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return getJSON(base + sep + 'view=dc-taste').then(function (first) {
      var recs = Array.isArray(first.p) ? first.p : [];
      var pages = Math.min(Number(first.pages) || 1, MAX_PAGES), more = [];
      for (var pg = 2; pg <= pages; pg++) more.push(getJSON(base + sep + 'view=dc-taste&page=' + pg).then(function (d) { return Array.isArray(d.p) ? d.p : []; }));
      return Promise.all(more).then(function (rest) { rest.forEach(function (r) { recs = recs.concat(r); }); return recs; });
    });
  }
  var indexPromise = null;
  function loadIndex() {
    if (indexPromise) return indexPromise;
    var r = rootPath(), k = KEY + ':' + r;
    var cached = cacheGet(k);
    if (cached) return (indexPromise = Promise.resolve(cached));
    var sources = [r + 'collections/types?q=Coffee', r + 'collections/types?q='];
    var ok = 0;
    indexPromise = Promise.all(sources.map(function (s) {
      return fetchSource(s).then(function (recs) { ok++; return recs; }, function () { return null; });
    })).then(function (lists) {
      var seen = {}, all = [];
      lists.forEach(function (l) { (l || []).forEach(function (rec) { if (rec && rec.h && !seen[rec.h]) { seen[rec.h] = 1; all.push(rec); } }); });
      if (!ok) throw new Error('taste index unavailable');
      if (ok === sources.length) cacheSet(k, all);
      return all;
    });
    return indexPromise;
  }

  /* ---------------- rendering ---------------- */
  var CSS = [
    '.dct-nw{white-space:nowrap}',
    '.dct-d{display:inline-block;width:7px;height:7px;border-radius:50%;background:var(--c,#8a8a8a);margin:0 4px 1px 0;vertical-align:middle}',
    '.dct-sr{position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
    '.dct-stars{--pct:100%;display:inline-block;font-size:12px;letter-spacing:1px;line-height:1;background:linear-gradient(90deg,#333 var(--pct),#c9c9c9 var(--pct));-webkit-background-clip:text;background-clip:text;color:transparent;white-space:nowrap}',
    /* More like this: 4 cards */
    '#dcMoreLike .dct-cards{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:28px}',
    '#dcMoreLike .dct-card{display:flex;flex-direction:column;text-decoration:none;color:#333;min-width:0}',
    '#dcMoreLike .dct-card:focus-visible{outline:2px solid #333;outline-offset:3px}',
    '#dcMoreLike .dct-card__im{aspect-ratio:4/5;background:#f4f4f4;border-radius:3px;display:flex;align-items:center;justify-content:center;padding:9%;overflow:hidden}',
    '#dcMoreLike .dct-card__im img{display:block;max-height:100%;max-width:100%;width:auto;height:auto;object-fit:contain;mix-blend-mode:multiply;transition:transform .3s}',
    '#dcMoreLike .dct-card:hover .dct-card__im img{transform:scale(1.03)}',
    '#dcMoreLike .dct-card__v{margin-top:14px;font-size:11.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#6b6b6b;line-height:1.35}',
    '#dcMoreLike .dct-card__n{font-size:20px;font-weight:600;line-height:1.15;margin:3px 0 0;color:#333}',
    '#dcMoreLike .dct-card__rp{font-size:13px;color:#6b6b6b;font-weight:600;margin-top:2px}',
    '#dcMoreLike .dct-card__why{margin-top:10px;padding-top:10px;border-top:1px solid #e8e8e8;font-size:14px;color:#4d4d4d;line-height:1.4}',
    '#dcMoreLike .dct-card__why b{font-weight:700;color:#333}',
    /* margin-top:auto: ratings and prices line up along the bottom of each row of cards */
    '#dcMoreLike .dct-card__meta{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:4px 8px;margin-top:auto;padding-top:10px;font-size:13px;color:#4d4d4d;font-weight:600}',
    '#dcMoreLike .dct-card__rt{display:inline-flex;align-items:center;gap:5px}',
    '#dcMoreLike .dct-card__rt small{font-size:13px;font-weight:500;color:#6b6b6b}',
    '#dcMoreLike .dct-card__pr{font-size:16px;font-weight:700;color:#333;margin-left:auto;white-space:nowrap}',
    /* Sold-out alternatives: compact rows */
    '#dcAlts .dct-alt{display:grid;grid-template-columns:60px minmax(0,1fr);gap:14px;align-items:center;padding:11px 16px;border-top:1px solid #e8e8e8;text-decoration:none;background:#fff;color:#333}',
    '#dcAlts .dct-alt:first-child{border-top:0}',
    '#dcAlts .dct-alt:hover{background:#fafafa}',
    '#dcAlts .dct-alt:focus-visible{outline:2px solid #333;outline-offset:-2px}',
    '#dcAlts .dct-alt__th{width:60px;height:60px;background:#f4f4f4;border-radius:3px;padding:5px;display:flex;align-items:center;justify-content:center;overflow:hidden}',
    '#dcAlts .dct-alt__th img{display:block;max-height:100%;max-width:100%;width:auto;height:auto;object-fit:contain;mix-blend-mode:multiply}',
    '#dcAlts .dct-alt__b{display:block;min-width:0}',
    '#dcAlts .dct-alt__top{display:flex;justify-content:space-between;align-items:baseline;gap:10px}',
    '#dcAlts .dct-alt__n{font-size:16.5px;font-weight:700;line-height:1.2;min-width:0}',
    '#dcAlts .dct-alt__pr{font-size:15px;font-weight:700;white-space:nowrap}',
    '#dcAlts .dct-alt__pr small{font-size:12px;font-weight:600;color:#6b6b6b;margin-right:3px}',
    '#dcAlts .dct-alt__sub{display:block;font-size:13px;color:#6b6b6b;line-height:1.3;margin:1px 0 2px}',
    '#dcAlts .dct-alt__rt{display:flex;align-items:center;gap:6px;font-size:13px;color:#4d4d4d;font-weight:600}',
    '#dcAlts .dct-alt__rt small{font-size:13px;font-weight:500;color:#6b6b6b}',
    '#dcAlts .dct-alt__why{display:block;font-size:13px;color:#4d4d4d;line-height:1.35;margin-top:2px}',
    '#dcAlts .dct-alt__why b{font-weight:700;color:#333}',
    /* the shared-reason line sits on the dark panel header: plain text there, as in the mockup */
    '#dcSoldOutPanel [data-dc-alts-reason] .dct-d{display:none}',
    '@media (max-width:1100px){#dcMoreLike .dct-cards{gap:20px}}',
    '@media (max-width:899px){' +
      '#dcMoreLike .dct-cards{grid-template-columns:repeat(2,minmax(0,1fr));gap:24px 14px}' +
      '#dcMoreLike .dct-card__n{font-size:17px}' +
      '#dcMoreLike .dct-card__why{font-size:13px}' +
      '#dcMoreLike .dct-card__meta{flex-direction:column;align-items:flex-start;gap:2px}' +
      '#dcMoreLike .dct-card__pr{margin-left:0}' +
      '#dcAlts .dct-alt{padding:10px 14px;gap:12px;grid-template-columns:56px minmax(0,1fr)}' +
      '#dcAlts .dct-alt__th{width:56px;height:56px}' +
      '#dcAlts .dct-alt__n{font-size:16px}' +
    '}',
    '@media (prefers-reduced-motion:reduce){#dcMoreLike .dct-card__im img{transition:none}#dcMoreLike .dct-card:hover .dct-card__im img{transform:none}}'
  ].join('\n');

  function injectCSS() {
    if (document.getElementById('dctStyle')) return;
    var s = document.createElement('style');
    s.id = 'dctStyle';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }
  function starsHTML(r) {
    var s = Number(r.s) || 0, c = Number(r.c) || 0;
    if (c < 1 || s <= 0) return '';
    var pct = Math.max(0, Math.min(100, s / 5 * 100)).toFixed(1);
    return '<span class="dct-stars" style="--pct:' + pct + '%" aria-hidden="true">★★★★★</span>' +
      '<span aria-hidden="true">' + s.toFixed(2) + ' <small>(' + c + ')</small></span>' +
      '<span class="dct-sr">Rated ' + s.toFixed(2) + ' out of 5 from ' + c + ' review' + (c === 1 ? '' : 's') + '</span>';
  }
  function imgAt(src, w) { return String(src || '').replace(/([?&])width=\d+/, '$1width=' + w); }
  function hrefOf(r) {
    var u = r.u || (rootPath() + 'products/' + r.h);
    return String(u).split('?')[0].split('#')[0];
  }
  function cardHTML(p) {
    var r = p.rec, roast = ROAST_LABEL[lc(r.b)] || '', ih = Number(r.ih) || 500;
    var img = r.i ? '<img src="' + esc(r.i) + '" alt="" loading="lazy" decoding="async" width="400" height="' + ih + '">' : '';
    var rt = starsHTML(r);
    return '<a class="dct-card" href="' + esc(hrefOf(r)) + '" data-dct-h="' + esc(r.h) + '">' +
      '<span class="dct-card__im">' + img + '</span>' +
      '<span class="dct-card__v">' + esc(r.v) + '</span>' +
      '<span class="dct-card__n">' + esc(r.t) + '</span>' +
      (roast ? '<span class="dct-card__rp">' + roast + '</span>' : '') +
      '<span class="dct-card__why"><b>Shares:</b> ' + reasonHTML(p.reason) + '</span>' +
      '<span class="dct-card__meta">' + (rt ? '<span class="dct-card__rt">' + rt + '</span>' : '') +
      '<span class="dct-card__pr">From ' + esc(money(r.p)) + '</span></span>' +
    '</a>';
  }
  function altHTML(p, extra) {
    var r = p.rec, roast = ROAST_LABEL[lc(r.b)] || '', ih = Number(r.ih) || 500;
    var img = r.i ? '<img src="' + esc(imgAt(r.i, 160)) + '" alt="" loading="lazy" decoding="async" width="50" height="' + Math.round(50 * ih / 400) + '">' : '';
    var rt = starsHTML(r);
    return '<a class="dct-alt" href="' + esc(hrefOf(r)) + '" data-dct-h="' + esc(r.h) + '">' +
      '<span class="dct-alt__th">' + img + '</span>' +
      '<span class="dct-alt__b">' +
        '<span class="dct-alt__top"><span class="dct-alt__n">' + esc(r.t) + '</span><span class="dct-alt__pr"><small>From</small>' + esc(money(r.p)) + '</span></span>' +
        '<span class="dct-alt__sub">' + esc(r.v) + (roast ? ' · ' + roast : '') + '</span>' +
        (rt ? '<span class="dct-alt__rt">' + rt + '</span>' : '') +
        (extra.length ? '<span class="dct-alt__why"><b>Shares:</b> ' + reasonHTML(extra) + '</span>' : '') +
      '</span>' +
    '</a>';
  }

  function renderMoreLike(sec, picks) {
    if (!sec || picks.length < 2) return 0;
    var box = sec.querySelector('[data-dc-cards]');
    if (!box) return 0;
    injectCSS();
    box.classList.add('dct-cards');
    box.innerHTML = picks.map(cardHTML).join('');
    var sub = sec.querySelector('[data-dc-more-sub]'), kinds = kindsOf(picks);
    if (sub && kinds.length) {
      sub.textContent = 'In-stock coffees from other roasters that share its ' + orList(kinds.map(function (k) { return k === 'flavour' ? 'flavours' : k; })) + '.';
    }
    sec.hidden = false;
    sec.removeAttribute('hidden');
    return picks.length;
  }
  function showFallback(panel, on) {
    var fb = panel.querySelectorAll('[data-dc-alts-fallback], #dcAltsFallback');
    for (var i = 0; i < fb.length; i++) {
      fb[i].hidden = !on;
      /* no empty footer strip when the fallback was its only link */
      var foot = fb[i].parentNode, vis = false;
      if (foot && foot !== panel && foot.id !== 'dcAlts') {
        for (var j = 0; j < foot.children.length; j++) if (!foot.children[j].hidden) vis = true;
        foot.hidden = !vis;
      }
    }
  }
  function settle(panel, n) {
    var list = document.getElementById('dcAlts');
    if (list) list.removeAttribute('aria-busy');
    panel.classList.remove('dcv-alts--loading');
    panel.setAttribute('data-dc-alts-count', String(n));
  }
  /* No alternatives (0 picks, no taste signals, index failed or too slow): promise nothing, point to the fallback link */
  function noAlts(panel) {
    panel = panel || document.getElementById('dcSoldOutPanel');
    if (!panel) return 0;
    var list = document.getElementById('dcAlts');
    if (list && !list.querySelector('.dct-alt')) list.innerHTML = '';
    if (list && list.querySelector('.dct-alt')) return 0; /* rows already rendered: keep them */
    var ttl = panel.querySelector('[data-dc-alts-title]');
    if (ttl) ttl.textContent = TITLE_NONE;
    var why = panel.querySelector('[data-dc-alts-reason]');
    if (why) why.textContent = '';
    showFallback(panel, true);
    var had = panel.getAttribute('data-dc-alts-count');
    settle(panel, 0);
    if (had !== '0') emit({ mode: 'soldout', count: 0, picks: [] });
    return 0;
  }
  function renderSoldOut(panel, picks) {
    var list = panel && document.getElementById('dcAlts');
    if (!list) return 0;
    if (!picks.length) return noAlts(panel);
    injectCSS();
    var sr = sharedReason(picks), commonKeys = {};
    sr.common.forEach(function (it) { commonKeys[it.k] = 1; });
    list.innerHTML = picks.map(function (p) {
      return altHTML(p, p.reason.filter(function (it) { return !commonKeys[it.k]; }));
    }).join('');
    var ttl = panel.querySelector('[data-dc-alts-title]');
    if (ttl) ttl.textContent = picks.length === 1 ? TITLE_ONE : TITLE_MANY;
    var why = panel.querySelector('[data-dc-alts-reason]');
    if (why) {
      if (sr.common.length) {
        why.innerHTML = 'All ' + (NUM_WORD[picks.length] || picks.length) + ' share: <b>' + reasonHTML(sr.common) + '</b>';
      } else {
        /* only the kinds of match these picks really have (never "flavour, process and origin" by default) */
        why.textContent = (picks.length > 1 ? 'From other roasters' : 'From another roaster') + ', matched on ' + orList(kindsOf(picks));
      }
      why.hidden = false;
    }
    showFallback(panel, picks.length < 2);
    settle(panel, picks.length);
    return picks.length;
  }

  function emit(detail) {
    try { document.dispatchEvent(new CustomEvent('dc:taste:rendered', { detail: detail })); } catch (e) { /* old browsers */ }
  }

  function run(d, mode) {
    var idx = loadIndex(), timer = 0;
    if (mode === 'soldout') {
      /* the panel shows skeleton rows: never leave them up for long */
      idx = Promise.race([idx, new Promise(function (res, rej) { timer = setTimeout(function () { rej(new Error('taste index timeout')); }, SOLDOUT_TIMEOUT); })]);
    }
    return idx.then(function (index) {
      clearTimeout(timer);
      var cur = currentSignals(d, index);
      if (!cur.fams.length && !cur.origins.length && !cur.procs.length) { if (mode === 'soldout') noAlts(); return; }
      var picks = pick(cur, index, PICKS);
      api.lastPicks = picks.map(function (p) { return { h: p.rec.h, v: p.rec.v, t: p.rec.t, score: p.score, reason: reasonText(p.reason) }; });
      var n = 0;
      if (mode === 'soldout') n = renderSoldOut(document.getElementById('dcSoldOutPanel'), picks);
      else n = renderMoreLike(document.getElementById('dcMoreLike'), picks);
      emit({ mode: mode, count: n, picks: api.lastPicks });
    })['catch'](function () {
      clearTimeout(timer);
      /* no index -> sold out: the no-alternatives state; otherwise leave the page as rendered */
      if (mode === 'soldout') noAlts();
    });
  }

  function readData() {
    var el = document.getElementById('dcPdpData');
    if (!el) return null;
    try { return JSON.parse(el.textContent || el.innerText || ''); } catch (e) { return null; }
  }

  var started = false;
  function boot() {
    if (started || typeof document === 'undefined' || typeof fetch !== 'function') return;
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); return; }
    var d = readData();
    if (!d || !d.handle) return;
    var panel = document.getElementById('dcSoldOutPanel');
    if (!arr(d.families).length && !arr(d.origins).length && !arr(d.processes).length && !d.roast) { /* gear, gift cards */
      if (panel && d.available === false) noAlts(panel);
      return;
    }
    var sec = document.getElementById('dcMoreLike');
    var soldOut = d.available === false && !!panel;
    if (!soldOut && !sec) return;
    started = true;
    if (soldOut) { run(d, 'soldout'); return; }

    var fired = false, waited = false;
    function fire() { if (!fired) { fired = true; run(d, 'more'); } }
    function go() {
      if (fired) return;
      if (document.readyState === 'complete') { fire(); return; }
      /* stay off the critical path: wait for the load event (at most 3 s once the section is near) */
      if (waited) return;
      waited = true;
      window.addEventListener('load', fire);
      setTimeout(fire, 3000);
    }
    /* near the viewport: #dcMoreLike is [hidden] (no box), so watch a 1px sentinel placed just before it */
    if ('IntersectionObserver' in window && sec.parentNode) {
      var s = document.createElement('div');
      s.setAttribute('aria-hidden', 'true');
      s.setAttribute('data-dct-sentinel', '');
      s.style.cssText = 'height:1px;margin-top:-1px;pointer-events:none';
      sec.parentNode.insertBefore(s, sec);
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { io.disconnect(); go(); return; }
      }, { rootMargin: '1200px 0px 1200px 0px' });
      io.observe(s);
    } else {
      go();
      return;
    }
    /* or when the browser is idle after load (never competes with the LCP image) */
    function idle() {
      if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 8000 });
      else setTimeout(go, 2500);
    }
    if (document.readyState === 'complete') setTimeout(idle, 1500);
    else window.addEventListener('load', function () { setTimeout(idle, 1500); });
  }

  var api = {
    boot: boot, pick: pick, currentSignals: currentSignals, reasonText: reasonText, sharedReason: sharedReason,
    kindsOf: kindsOf, noAlts: noAlts, vkey: vkey, loadIndex: loadIndex, lastPicks: null
  };
  return api;
});
